export const productFilter = '{$or:[{id:`int`},{unhide_pid:`int`}]}'
export const branchFilter = '{$or:[{bid:`int`},{unhide_bid:`int`},{name:"%`value`%"}]}'
export const memberFilter = '{$or:[{uid:`int`},{unhide_uid:`int`}]}'
export const hotsearchFilter = '{keyword:"%`value`%"}'
export const giftcardFilter = '{name:"%`value`%"}'
export const titleFilter = '{name:"%`value`%"}'
export const reviewFilter = '{description:"%`value`%"}'
export const filterFilter = '{$or:[{name:"%`value`%"},{title:"%`value`%"}]}'
export const idTitleFilter = '{$or:[{id:`int`},{title:"%`value`%"}]}'
export const regionFilter = '{$or:[{id:`int`},{name:"%`value`%"}]}'
export const promoCodeFilter = '{$or:[{id:`int`},{promo_code_list_code:"`value`%"}]}'
export const adminUserFilter = '{$or:[{uid:`int`},{auth_id:"`value`%"},{email:"`value`%"}]}'
export const prodtagFilter = function (type) {
  let t = ''
  if (type !== null) {
    t = ',type:' + type
  }
  return '{$or:[{id:`int`},{name:"%`value`%"},{group_name:"%`value`%"}]' + t + '}'
}

export function updateFilter (name) {
  this.filteredValue.splice(0, this.filteredValue.length)
  let q = this.$route.query[name]
  if (typeof q === 'undefined') {
    if (this.$parent && this.$parent.clearFilter) {
      this.$parent.clearFilter([name])
    }
    return
  }
  let arr = q.split(',')
  for (let i = 0; i < arr.length; i++) {
    let n = parseInt(arr[i])
    this.filteredValue.push((isNaN(n)) ? arr[i] : n)
  }
}

export function parseField (base, n) {
  if (typeof n !== 'undefined' && n !== null) {
    let arr = n.toString().split('.', 2)
    if (Array.isArray(arr) && arr.length === 2) {
      return arr
    }
  }
  return [this.base, n]
}
